import { render } from "./ProgramInterlos.vue?vue&type=template&id=11f1799d"
import script from "./ProgramInterlos.vue?vue&type=script&lang=js"
export * from "./ProgramInterlos.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__